var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoginApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.327 5.562C10.9759 5.50301 11.607 5.31788 12.185 5.017C12.753 4.72213 13.2555 4.31529 13.662 3.821C14.4796 2.88985 14.9511 1.70528 14.997 0.467C15.0113 0.311663 15.0113 0.155337 14.997 0C13.574 0.146 12.27 0.817 11.367 1.867C10.5519 2.75443 10.079 3.9029 10.033 5.107C10.0111 5.2495 10.0111 5.39451 10.033 5.537L10.327 5.562ZM6.417 24C7.939 24 8.606 23.004 10.5 23.004C12.395 23.004 12.849 23.974 14.503 23.974C16.157 23.974 17.265 22.474 18.306 21.011C19.0304 19.9671 19.6009 18.8244 20 17.618C19.0253 17.2104 18.1886 16.5306 17.59 15.66C17.0084 14.8111 16.6993 13.805 16.704 12.776C16.7112 11.8579 16.9595 10.9579 17.424 10.166C17.899 9.35747 18.5691 8.68086 19.373 8.198C18.827 7.4425 18.102 6.83433 17.263 6.428C16.4079 6.01279 15.4664 5.80679 14.516 5.827C12.648 5.827 11.127 6.924 10.18 6.924C9.233 6.924 7.792 5.89 6.177 5.89C3.109 5.89 0 8.412 0 13.015C0.06 15.835 0.952001 18.582 2.575 20.948C3.83 22.625 4.882 24 6.417 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginApple);
export default __webpack_public_path__ + "static/media/icon_login_apple.15e68191ff83135cd56691837cc2dad6.svg";
export { ForwardRef as ReactComponent };